// Subscription plan constants for EasyLister.
// Infinity = Unlimited, 0 = Locked / not included.
// Use formatLimit() / formatDevices() for display strings.

export const PLAN_IDS = {
  TRIAL: "trial",
  STARTER: "starter",
  GROWTH: "growth",
  PRO: "pro",
};

export const SUBSCRIPTION_PLANS = {
  trial: {
    id: "trial",
    name: "Trial",
    price: 0,
    priceLabel: "₹0",
    period: "3 days",
    isFree: true,
    tagline: "No card needed",
    badge: "Free trial",
    popular: false,
    cta: "Start Free Trial",
    icon: "Gift",
    limits: {
      aiListing: 2,
      titleOptimise: 3,
      descriptionSeo: 3,
      xlsxExport: 1,
      enhancementAi: 2,
    },
    devices: 1,
    loginElsewhere: "auto_logout",
    loginElsewhereLabel: "Auto logout",
  },
  starter: {
    id: "starter",
    name: "Starter",
    price: 149,
    priceLabel: "₹149",
    period: "month",
    isFree: false,
    tagline: "Best for new sellers",
    badge: "Starter",
    popular: false,
    cta: "Get Starter",
    icon: "Zap",
    limits: {
      aiListing: 5,
      titleOptimise: 10,
      descriptionSeo: 10,
      xlsxExport: 3,
      enhancementAi: 5,
    },
    devices: 2,
    loginElsewhere: "oldest_logout",
    loginElsewhereLabel: "Oldest logs out",
  },
  growth: {
    id: "growth",
    name: "Growth",
    price: 399,
    priceLabel: "₹399",
    period: "month",
    isFree: false,
    tagline: "Best for active sellers",
    badge: "Most popular",
    popular: true,
    cta: "Get Growth",
    icon: "TrendingUp",
    limits: {
      aiListing: 15,
      titleOptimise: 30,
      descriptionSeo: 30,
      xlsxExport: 10,
      enhancementAi: 10,
    },
    devices: 3,
    loginElsewhere: "oldest_logout",
    loginElsewhereLabel: "Oldest logs out",
  },
  pro: {
    id: "pro",
    name: "Pro",
    price: 799,
    priceLabel: "₹799",
    period: "month",
    isFree: false,
    tagline: "Power sellers",
    badge: "Pro",
    popular: false,
    cta: "Get Pro",
    icon: "Crown",
    limits: {
      aiListing: 50,
      titleOptimise: Infinity,
      descriptionSeo: Infinity,
      xlsxExport: Infinity,
      enhancementAi: Infinity,
    },
    devices: 5,
    loginElsewhere: "oldest_logout",
    loginElsewhereLabel: "Oldest logs out",
  },
};

export const PLAN_LIST = ["trial", "starter", "growth", "pro"].map(
  (id) => SUBSCRIPTION_PLANS[id],
);

export const AI_FEATURE_ROWS = [
  { key: "aiListing", label: "AI listing" },
  { key: "titleOptimise", label: "Title optimise" },
  { key: "descriptionSeo", label: "Description + SEO" },
  { key: "xlsxExport", label: "XLSX export" },
  { key: "enhancementAi", label: "Enhancement AI" },
];

export const FREE_FEATURE_ROWS = [
  { key: "labels", label: "Labels" },
  { key: "inventoryScan", label: "Inventory scan" },
  { key: "autoFillScan", label: "Auto-fill scan" },
];

export const DEVICE_SESSION_DESCRIPTIONS = {
  trial: "Login on 2nd device = instant logout on 1st",
  starter: "3rd device login = oldest session logs out",
  growth: "4th device login = oldest session logs out",
  pro: "6th device login = oldest session logs out",
};

// Returns { label, colorClass } for a feature limit value.
export function formatLimit(value) {
  if (value === Infinity) return { label: "Unlimited", colorClass: "text-emerald-600" };
  if (value === 0) return { label: "Locked", colorClass: "text-slate-400" };
  return { label: `${value} / day`, colorClass: "text-orange-500" };
}

// Returns { label, colorClass } for device count.
export function formatDevices(value) {
  if (value === Infinity) return { label: "Unlimited", colorClass: "text-purple-600" };
  return { label: `${value} device${value !== 1 ? "s" : ""}`, colorClass: "text-orange-500" };
}

export function getPlanById(planId) {
  return SUBSCRIPTION_PLANS[planId] ?? null;
}
